import type { CustomTrackDefinition } from "./customTrackSchema";
import type { TrackTheme } from "./track";

// Owner-approved v1 THEME_PALETTES (public/play3d.html). Palette, floor and
// props remain independent editor choices; this table only resolves colors.
const palettes = {
  bartop: [0x4a4038, 0xb23a2e, 0xefe0bb, 0x17110d, 0xd6a951, 0x100d0b],
  brewery: [0x485e67, 0xe2a31d, 0xd7b35d, 0x15191b, 0xde854c, 0x0c1114],
  garden: [0x9a8665, 0xf1ead1, 0xe6e0bc, 0x101a13, 0x8fd36d, 0x0b130d],
  rooftop: [0x47435e, 0x16d9d0, 0xf0dcff, 0x090b18, 0xdc6eff, 0x080913],
  cellar: [0x554a40, 0x672d20, 0xd8c3a2, 0x100d0c, 0xb87151, 0x090706],
  oktoberfest: [0x9b6b3e, 0x1763a3, 0xfff0c2, 0x18130c, 0xe9b947, 0x110d08],
  icebar: [0x3f7187, 0x176da0, 0xe7fbff, 0x0a141c, 0x77dff2, 0x071018],
  distillery: [0x554941, 0xa74f27, 0xf0d0ae, 0x17100c, 0xd7834f, 0x100a07],
  roadhouse: [0x393238, 0xf0d9b5, 0xf2d29b, 0x18100b, 0xe99353, 0x110b08],
  harbour: [0x344956, 0xe1b957, 0xd5eef2, 0x07141a, 0x5bc6dd, 0x071014],
  velvet: [0x261f2a, 0xc69a58, 0xf3d8c7, 0x160b13, 0xd56d9b, 0x10080d],
  courtyard: [0xdfc497, 0x1269aa, 0xfff0cc, 0x17150f, 0xe5c15c, 0x100f0b],
  moon: [0x565d70, 0x7b6bb3, 0xdce2ff, 0x080914, 0x99a8ff, 0x070810],
} as const;

export const CUSTOM_TRACK_THEME_KEYS = Object.freeze(Object.keys(palettes));

/** Unknown legacy tokens retain v1's Bar Top palette fallback. */
export function getCustomTrackTheme(definition: CustomTrackDefinition): TrackTheme {
  const palette = Object.prototype.hasOwnProperty.call(palettes, definition.themeKey)
    ? palettes[definition.themeKey as keyof typeof palettes] : palettes.bartop;
  const [road, defaultKerb, edge, venue, defaultGlow, fog] = palette;
  const floorVenue = definition.floorKey && Object.prototype.hasOwnProperty.call(palettes, definition.floorKey)
    ? palettes[definition.floorKey as keyof typeof palettes][3] : venue;
  const tint = (value: string | undefined, fallback: number) => value === undefined ? fallback : Number.parseInt(value.slice(1), 16);
  const kerb = tint(definition.tint?.kerb, defaultKerb);
  const line = tint(definition.tint?.line, 0xf3eee1);
  const accent = tint(definition.tint?.glow, defaultGlow);
  return { sky: venue, fog, ground: floorVenue, road, kerb, line, shortcut: road,
    barrierA: kerb, barrierB: edge, accent, foliage: venue, trunk: venue };
}
